import styled from '@emotion/styled';
import { Grid } from '@material-ui/core';
import { Magnetic } from '@mitchell/react.component.ux';
const flexCss = `
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	align-items: center;
`;
export const StyledGrid = styled(Grid) `
	max-width: 100%;
	@media (max-width: 414px) {
		max-width: 345px;
	}
	@media (max-width: 300px) {
		max-width: 315px;
	}
	padding: ${Magnetic.spacer16} 0;
`;
export const StyledHr = styled('hr') `
	width: 50px;
`;
export const StyledOr = styled('div') `
	font-size: ${Magnetic.fontSize14};
	padding: 0px ${Magnetic.spacer16};
`;
export const StyledVinDivContainer = styled('div') `
	margin: ${Magnetic.spacer08} 0 ${Magnetic.spacer08} 0;
	#PHOTO_CAPTURE_vinDecode__vin-input,
	#vinScanButton {
		width: 100%;
		@media screen and (min-device-width: 414px) {
			width: 315px;
		}
	}

	@media screen and (min-device-width: 414px) {
		${flexCss}
	}
	.mi-vehicle-flyout > .mi-flyout,
	.flyoutContainer {
		width: 100%;
	}
`;
export const StyledImageDiv = styled(Grid) `
	position: relative;
	display: inline-block;
	#Intelligent_Guided_Photo_Capture_defaultImageSection {
		margin: ${Magnetic.spacer08} auto !important;
	}
`;
export const StyledVinDecodeSection = styled('div') `
	padding: 0 ${Magnetic.spacer24} ${Magnetic.spacer24} ${Magnetic.spacer24};
	box-sizing: inherit;
	${flexCss}
`;
export const StyledVehicleAttributeContainer = styled('div') `
	margin-top: ${Magnetic.spacer12};
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;

	> * {
		width: 100%;
		max-width: 315px;
		margin: 0 auto;
	}
`;
//# sourceMappingURL=VinDecodeComponent.style.js.map